import { hide } from '../js/modules/modal';

// close talk to sales modal on click btn in success page
const onboardingAPIModal = $('#onboarding-apis-modal');
const modalCloseBtn = $('#onbr-modal-close-btn');

const hideModal = () => {
  hide(onboardingAPIModal);
};

modalCloseBtn.on('click', () => {
  hideModal();
});

// animation hero image
const not_safari = !/^((?!chrome|android).)*safari/i.test(navigator.userAgent);
const heroSVG = document.getElementById('hero-desktop');
if (not_safari) {
  heroSVG.classList.add('animate-planets');
}

// for on click redirection of login button on partner landing page
const partnerURL =
  'https://accounts.razorpay.com/auth/?redirecturl=https%3A%2F%2Fdashboard.razorpay.com%2Fapp%2Fpartners&auth_intent=login';
document.querySelector('[data-partner-signin]').href = partnerURL;
